import React, {useState} from "react";
import UserSelectionChips, {
    DEFAULT_COLLAPSED_VISIBLE,
    UserSelectionListModal,
    UserSelectionToolbar,
} from "./UserSelectionChips";
import "./userSelectionChips.css";

const INLINE_COLLAPSED_VISIBLE = 2;

function UserSelectionField({
    data,
    onRemove,
    readonly,
    style,
    countUnit,
    chipEntity,
    listModalTitle = "선택 목록",
    children,
    layout = "stack",
}) {
    const [listModalOpen, setListModalOpen] = useState(false);
    const isInline = layout === "inline";
    const collapsedVisible = isInline ? INLINE_COLLAPSED_VISIBLE : DEFAULT_COLLAPSED_VISIBLE;

    const fieldClassName = [
        "px-[12px] user-selection-field",
        isInline ? "user-selection-field--inline" : "",
    ]
        .filter(Boolean)
        .join(" ");

    const modal = (
        <UserSelectionListModal
            open={listModalOpen}
            onClose={() => setListModalOpen(false)}
            data={data}
            chipEntity={chipEntity}
            onRemove={onRemove}
            readonly={readonly}
            countUnit={countUnit}
            title={listModalTitle}
        />
    );

    if (isInline) {
        return (
            <>
                <div className={fieldClassName} style={style}>
                    <div className="user-selection-field-row">
                        <div className="user-selection-field-start">
                            {children}
                            <UserSelectionToolbar
                                data={data}
                                onViewAll={() => setListModalOpen(true)}
                                countUnit={countUnit}
                                collapsedVisible={collapsedVisible}
                            />
                        </div>
                        <UserSelectionChips
                            data={data}
                            onRemove={onRemove}
                            readonly={readonly}
                            countUnit={countUnit}
                            chipEntity={chipEntity}
                            showHeader={false}
                            collapsedVisible={collapsedVisible}
                        />
                    </div>
                </div>
                {modal}
            </>
        );
    }

    return (
        <>
            <div className={fieldClassName} style={style}>
                <div className="user-selection-field-toolbar">
                    {children}
                    <UserSelectionToolbar
                        data={data}
                        onViewAll={() => setListModalOpen(true)}
                        countUnit={countUnit}
                        collapsedVisible={collapsedVisible}
                    />
                </div>
                <UserSelectionChips
                    data={data}
                    onRemove={onRemove}
                    readonly={readonly}
                    countUnit={countUnit}
                    chipEntity={chipEntity}
                    showHeader={false}
                    collapsedVisible={collapsedVisible}
                />
            </div>
            {modal}
        </>
    );
}

export default UserSelectionField;
